/**
 * Planned Works Module - Main Entry Point
 * Redirects to the PlannedWorksDashboard
 */

import React from 'react';
import { PlannedWorksDashboard } from './PlannedWorksDashboard';

const PlannedWorks: React.FC = () => {
  return <PlannedWorksDashboard />;
};

export default PlannedWorks; 